import React, { useEffect } from "react";
import "./app.css";
import FormLicenceGenerator from "../components/form/FormLicenceLuna.jsx";
import FormLicenceExoClinic from "../components/form/FormLicenceExoClinic.jsx";
import Header from "../components/header/Header.jsx";
import { DeviceSelector, DeviceType } from "./DeviceSelector";
import { Route, Switch, useHistory, useLocation } from "react-router-dom";

function DeviceSelectorWithNavigation({ selectedDevice, onSelect }: { selectedDevice: DeviceType | null; onSelect: (d: DeviceType) => void }) {
  const history = useHistory();
  return (
    <DeviceSelector
      selectedDevice={selectedDevice}
      onSelect={(device) => {
        onSelect(device);
        history.push("/generator");
      }}
    />
  );
}

export default function App() {
  const [selectedDevice, setSelectedDevice] = React.useState<DeviceType | null>(null);
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/") {
      setSelectedDevice(null);
    }
  }, [location.pathname]);

  return (
    <div className="wrapper">
      <Header />
      <Switch>
        <Route exact path="/">
          <DeviceSelectorWithNavigation
            selectedDevice={selectedDevice}
            onSelect={setSelectedDevice}
          />
        </Route>
        <Route path="/generator" render={() => (
          selectedDevice === "luna"
            ? <FormLicenceGenerator deviceType={selectedDevice} />
            : <FormLicenceExoClinic deviceType={selectedDevice} />
        )} />
      </Switch>
    </div>
  );
}
